export function emptyForm() {
return [   // executes on default in switch stmt formFieldData.js
    
]
}